export default __webpack_public_path__ + "locales/ja-JP/DeleteThirdPartyDialog.json?hash=c7f64f861f41c99b2401737da5ccaca4";